import React, { useCallback, useEffect, useState } from "react";
import { Icon, SelectField } from "@culturehq/components";
import { debounce } from "lodash";
import client from "@culturehq/client";

import tagsTypes from "constants/tagsTypes";
import styled from "styled-components";
import { t } from "app/utils";

const StyledSelectField = styled(SelectField)`
  .chq-ffd--sl {
    .chq-ffd--ctrl {
      flex-wrap: ${({ withContent }: any) => `${withContent ? "wrap" : "nowrap"}`} !important;
    }
  }
`;

const SelectUsers = ({ value, multiple = true, placeholder = "Select users", options, onChange, children = null }: any) => {
  const [addedOptions, setAddedOptions] = useState<any[]>([]);
  const SEARCH_DELAY = 500;

  useEffect(() => {
    if (!options?.length) return;

    const filteredOptions = options.filter((user: any) => (
      !addedOptions.some((option: any) => option.value === user.value)
    ));

    setAddedOptions(prev => [...prev, ...filteredOptions]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  const performSearch = async (query: any) => {
    const { entities } = await (client as any).autocompleteMentions({ query });
    const users = entities.filter((entity: any) => (
      entity.type === "users" && !addedOptions.some((option: any) => option.value === entity.id)
    ));
    setAddedOptions([...addedOptions, ...users.map((user: any) => (
      {
        category: tagsTypes.USERS,
        categoryIcon: "user",
        icon: "user-filled",
        label: user.name,
        value: user.id
      }
    ))]);
  };

  const debouncedEnqueueSearch = useCallback(debounce(performSearch, SEARCH_DELAY), [addedOptions]);

  const handleTextChange = (value: any) => {
    debouncedEnqueueSearch(value);
  };

  return (
    <div className="Select-Tags__Container">
      <StyledSelectField
        name="inviter"
        className="share-with-field"
        placeholder={t(placeholder)}
        multiple={multiple}
        options={addedOptions}
        value={value}
        onChange={onChange}
        onTextChanged={handleTextChange}
      >
        <Icon icon="search" />
        {children}
      </StyledSelectField>
    </div>
  );
};

export default SelectUsers;
